import { useContext } from 'react';
import { billingHeaderContext } from './billing-header-context';

export function useBillingHeaderProvider() {
  const billingHeader = useContext(billingHeaderContext);
  if (!billingHeader) {
    throw new Error(
      'billingHeaderContext value is undefined. Make sure you use the billingHeaderProvider before using the context.'
    );
  }
  return billingHeader;
}
